export class ItemStyle {
  id: number | undefined;
  color: string = "#000000";
  font_size: string = "12px";
  width: string = "100%";
  height: string = "100%";
  margin_top: string = "0px";
  margin_bottom: string = "0px";
  margin_right: string = "0px";
  margin_left: string = "0px";
  padding_top: string = "5px";
  padding_bottom: string = "5px";
  padding_right: string = "5px";
  padding_left: string = "5px";
  border_radius: string = "0px";
  border_style = "solid";
  border_color: string = "#000000";
  border_top_width: string = "0px";
  border_bottom_width: string = "0px";
  border_right_width: string = "0px";
  border_left_width: string = "0px";
  font_family: string = "vzr";
  font_weight: string = "100";
  background_color: string = "#ffffff";


  public static getStyle(styl:ItemStyle):string{
    let style:string="";
    style+="color:"+styl.color+";";
    style+="font_size:"+styl.font_size+";";
    style+="width:"+styl.width+";";
    style+="height:"+styl.height+";";
    style+="margin_top:"+styl.margin_top+";";
    style+="margin_bottom:"+styl.margin_bottom+";";
    style+="margin_right:"+styl.margin_right+";";
    style+="margin_left:"+styl.margin_left+";";
    style+="padding_top:"+styl.padding_top+";";
    style+="padding_bottom:"+styl.padding_bottom+";";
    style+="padding_right:"+styl.padding_right+";";
    style+="padding_left:"+styl.padding_left+";";
    style+="border_radius:"+styl.border_radius+";";
    style+="border_style:"+styl.border_style+";";
    style+="border_color:"+styl.border_color+";";
    style+="border_top_width:"+styl.border_top_width+";";
    style+="border_bottom_width:"+styl.border_bottom_width+";";
    style+="border_right_width:"+styl.border_right_width+";";
    style+="border_left_width:"+styl.border_left_width+";";
    style+="font_family:"+styl.font_family+";";
    style+="font_weight:"+styl.font_weight+";";
    style+="background_color:"+styl.background_color+";";
    return style;
  }
}
